import React from 'react';
import Draggable from 'react-draggable';
import { Button } from 'src/common/button';
import { Checkbox } from 'src/common/form/checkbox';
import { IconButton } from 'src/common/icon-button';
import { CloseStrongIcon } from 'src/monet/icons';
import { useFeatureFlagsStore } from './feature-flags-store';

export const FeatureFlagsPanel = () => {
  const { showPanel, flags, setFlag, closePanel, resetAllFlags } = useFeatureFlagsStore();
  if (!showPanel) {
    return null;
  }
  return (
    <Draggable>
      <div className='fixed z-[1000] right-4 top-4 rounded-lg bg-bedrock-black text-white p-4 flex flex-col items-stretch gap-3'>
        <div className='flex justify-between items-center'>
          <div className='text-neue-journey-medium-strong'>Feature flags</div>
          <IconButton onClick={() => closePanel()}>
            <CloseStrongIcon />
          </IconButton>
        </div>
        <div className='flex flex-col gap-2 p-2'>
          {(Object.entries(flags) as [keyof typeof flags, boolean][]).map(([key, value]) => (
            <div key={key} className='flex gap-2'>
              <Checkbox
                checked={value}
                onChange={(e, checked) => {
                  setFlag(key, checked);
                }}
              />
              <div className='text-neue-journey-medium truncate'>{key}</div>
            </div>
          ))}
        </div>
        <button
          className='self-start text-neue-journey-medium-strong transition hover:opacity-80'
          onClick={() => resetAllFlags()}
        >
          Reset All
        </button>
      </div>
    </Draggable>
  );
};
